<template>
  <div id="home">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><a @click="rectre('/')">Home</a></li>
      <li><a @click="rectre('/paket-mapel')">Bimbel Online</a></li>
      <li class="active">Paket Mata Pelajaran</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{ packData.name }}</h1>
    <!-- end page-header -->
    <div class="row">
        <div class="col-md-4 mb-3">
            <button class="btn btn-info" @click="showForm()"><i class="fa fa-plus"></i> <b>Tambah Bab</b></button>
        </div>
    </div>
    <div class="row-bab">
        <div class="row flex-nowrap">
            <bab v-for="(item,index) in packData.sections" v-bind:key="index" v-on:editBab="detailBab($event)" v-on:throwEdit="editContent($event)" v-on:reload="loadData()" :indexProp="index" :datalist="item" :mapelid="packData" v-on:addingcontent="addContentButton($event)"></bab>
        </div>
    </div>

    <div class="modal fade" id="addBabModal" tabindex="-1" role="dialog" aria-labelledby="addBabModalTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addBabModalTitle" v-if="postState === 0"><b>Tambah Bab</b></h5>
            <h5 class="modal-title" id="addBabModalTitle" v-if="postState === 1"><b>Update Bab</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Nama</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" class="form-control" required v-model="name">
                  </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Pilih Bab</label>
                    <div class="col-md-6 col-xs-6">
                      <div>
                        <select class="form-control" v-model="bab_name">
                            <option v-for="(item,index) in listBab" v-bind:key="index" :value="item.nama">{{item.nama}}</option>
                        </select>
                      </div>
                    </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Start Date*</label>
                  <transition name="fade">
                    <div class="col-md-4 col-xs-4">
                      <div class="input-group">
                        <input id="startDate" v-model="start_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="start_date" readonly>
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </transition>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label"></label>
                  <div class="col-md-4 col-xs-4">
                    <div class="input-group clockpicker">
                      <input id="startTime" v-model="start_time" type="text" class="form-control" placeholder="Jam : Menit" name="start_time" readonly>
                      <span class="input-group-btn">
                        <button class="btn btn-success" type="button">
                          <i class="fa fa-clock-o"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">End Date*</label>
                  <transition name="fade">
                    <div class="col-md-4 col-xs-4">
                      <div class="input-group">
                        <input id="endDate" v-model="end_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="end_date" readonly>
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </transition>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label"></label>
                  <div class="col-md-4 col-xs-4">
                    <div class="input-group clockpicker">
                      <input id="endTime" v-model="end_time" type="text" class="form-control" placeholder="Jam : Menit" name="end_time" readonly>
                      <span class="input-group-btn">
                        <button class="btn btn-success" type="button">
                          <i class="fa fa-clock-o"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label"></label>
                  <div class="col-md-2 col-xs-2">
                    <span style="font-weight:bold;">
                      <input type="checkbox" v-model="is_free"/> &nbsp;<b>Gratis</b>
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button v-if="postState === 0" type="button" class="btn btn-primary" @click="saveDataBab()">Simpan</button>
            <button v-if="postState === 1" type="button" class="btn btn-primary" @click="editDataBab()">Update</button>
          </div>
        </div>
      </div>
    </div>



    <!-- modal konten -->
    <div class="modal fade" :id="'kontenmodal'" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle" style="float:left;" v-if="idContent === null"><b>Tambah Konten </b></h5>
            <h5 class="modal-title" id="exampleModalLongTitle" style="float:left;" v-if="idContent !== null"><b>Update Konten </b></h5>
            <button type="button" class="close" @click="hideFormContent()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist" >
              <li class="nav-item">
                <a :class="type_id === 1 ? 'nav-link active' : type_id !== 1 && idContent !== null ? 'nav-link disabled': 'nav-link'" @click="idContent === null ? type_id = 1 : ''" id="video-tab" data-toggle="tab" href="#video" role="tab" aria-controls="video" aria-selected="true">Video</a>
              </li>
              <li class="nav-item">
                <a :class="type_id === 2 ? 'nav-link active' : type_id !== 2 && idContent !== null ? 'nav-link disabled': 'nav-link'" @click="idContent === null ? type_id = 2 : ''" id="materi-tab" data-toggle="tab" href="#materi" role="tab" aria-controls="materi" aria-selected="false">Materi</a>
              </li>
              <li class="nav-item">
                <a :class="type_id === 3 ? 'nav-link active' : type_id !== 3 && idContent !== null ? 'nav-link disabled': 'nav-link'" @click="idContent === null ? type_id = 3 : ''" id="latihan-tab" data-toggle="tab" href="#latihan" role="tab" aria-controls="latihan" aria-selected="false">Latihan Soal</a>
              </li>
              <!-- <li class="nav-item">
                <a :class="type_id === 5 ? 'nav-link active' : 'nav-link'" @click="type_id = 5" id="tryout-tab" data-toggle="tab" href="#tryout" role="tab" aria-controls="tryout" aria-selected="false">Tryout</a>
              </li> -->
              <li class="nav-item">
                <a :class="type_id === 4 ? 'nav-link active' : type_id !== 4 && idContent !== null ? 'nav-link disabled': 'nav-link'" @click="idContent === null ? type_id = 4 : ''" id="terjadwal-tab" data-toggle="tab" href="#terjadwal" role="tab" aria-controls="terjadwal" aria-selected="false">Tryout Terjadwal</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div v-if="type_id === 1">
              <!-- <div class="tab-pane fade show active" id="video" role="tabpanel" aria-labelledby="video-tab"> -->
                <div class="alert alert-danger fade in m-b-15" v-if="this.errorVideo.length > 0">
                  <span class="close" data-dismiss="alert">&times;</span>
                  <strong>Terjadi kesalahan!</strong>
                  <ul>
                    <li v-for="(message, key) in this.errorVideo" v-bind:key="key">{{message}}</li>
                  </ul>
                </div>
                <form>
                  <div class="form-horizontal form-bordered">
                    <div class="form-group">
                    <label class="col-md-2 control-label">Jenjang *</label>
                    <div class="col-md-6 col-xs-6">
                        <select class="form-control" disabled v-model="jenjang" @change="resetKelas()">
                            <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-if="jenjang">
                    <label class="col-md-2 control-label">Kelas *</label>
                    <div class="col-md-6 col-xs-6">
                      <div v-if="jenjang === 'SD'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMP'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMA'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                      </div>
                    </div>
                </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Judul</label>
                        <div class="col-md-6 col-xs-6">
                          <div>
                            <select class="form-control" v-model="video_judul">
                                <option v-for="(item,index) in listVideo" v-bind:key="index" :value="item">{{item.title}}</option>
                            </select>
                          </div>
                        </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Judul Alternatif</label>
                      <div class="col-md-6 col-xs-6">
                        <span>
                          <input type="text" class="form-control" v-model="video_judul_alt"/>
                        </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- <div class="tab-pane fade" id="materi" role="tabpanel" aria-labelledby="materi-tab"> -->
              <div v-if="type_id === 2">
                <div class="alert alert-danger fade in m-b-15" v-if="this.errorMateri.length > 0">
                  <span class="close" data-dismiss="alert">&times;</span>
                  <strong>Terjadi kesalahan!</strong>
                  <ul>
                    <li v-for="(message, key) in this.errorMateri" v-bind:key="key">{{message}}</li>
                  </ul>
                </div>
                <form>
                  <div class="form-horizontal form-bordered">
                    <div class="form-group">
                    <label class="col-md-2 control-label">Jenjang *</label>
                    <div class="col-md-6 col-xs-6">
                        <select class="form-control" disabled v-model="jenjang" @change="resetKelas()">
                            <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-if="jenjang">
                    <label class="col-md-2 control-label">Kelas *</label>
                    <div class="col-md-6 col-xs-6">
                      <div v-if="jenjang === 'SD'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMP'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMA'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                      </div>
                    </div>
                </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Judul</label>
                        <div class="col-md-6 col-xs-6">
                          <input type="text" class="form-control" v-model="materi_judul"/>
                        </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Upload</label>
                      <div class="col-md-6 col-xs-6" v-if="showLoader">
                        <img :src="loading"/>
                      </div>
                      <div class="col-md-6 col-xs-6" v-if="!showLoader">
                        <a :href="file_url" target="_blank" v-if="file_url !== ''" style="margin: 10px;"><i class="fa fa-file"></i>&nbsp; {{convertURL(file_url)}}</a>
                        <br v-if="file_url !== ''"/>
                        <br v-if="file_url !== ''"/>
                        <span>
                          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" class="form-control" :placeholder="[[ 'ganti file' ]]"/>
                        </span>
                        <div v-if="validFile === 1" style="color: green; font-size: 12px; padding: 5px;">File is Valid and uploaded!</div>
                        <div v-if="validFile === 2" style="color: red; font-size: 12px; padding: 5px;">upload gagal, pastikan jenis file yang dipilih adalah pdf</div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- <div class="tab-pane fade" id="latihan" role="tabpanel" aria-labelledby="latihan-tab"> -->
                <div v-if="type_id === 3">
                <div class="alert alert-danger fade in m-b-15" v-if="this.errorSoal.length > 0">
                  <span class="close" data-dismiss="alert">&times;</span>
                  <strong>Terjadi kesalahan!</strong>
                  <ul>
                    <li v-for="(message, key) in this.errorSoal" v-bind:key="key">{{message}}</li>
                  </ul>
                </div>
                <form>
                  <div class="form-horizontal form-bordered">
                    <div class="form-group">
                    <label class="col-md-2 control-label">Jenjang *</label>
                    <div class="col-md-6 col-xs-6">
                        <select class="form-control" disabled v-model="jenjang" @change="resetKelas()">
                            <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-if="jenjang">
                    <label class="col-md-2 control-label">Kelas *</label>
                    <div class="col-md-6 col-xs-6">
                      <div v-if="jenjang === 'SD'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMP'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMA'">
                        <select class="form-control" disabled v-model="kelas">
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                      </div>
                    </div>
                </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Bab</label>
                        <div class="col-md-6 col-xs-6">
                          <app-autocomplete ref="autocomplete" placeholder="Cari Bab" :data="babList" v-on:selected="assignBab($event)" :value="autoValueBab"></app-autocomplete>
                          <!-- {{babSelected}} -->
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Sub Bab</label>
                        <div class="col-md-6 col-xs-6">
                          <app-autocomplete ref="subbabautocomplete" placeholder="Cari Sub Bab" :data="subBabList" v-on:selected="assignSubBab($event)" :value="autoValueSubBab"></app-autocomplete>
                        </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="tab-pane fade" id="tryout" role="tabpanel" aria-labelledby="tryout-tab">
                <div class="alert alert-danger fade in m-b-15" v-if="this.errorTryout.length > 0">
                  <span class="close" data-dismiss="alert">&times;</span>
                  <strong>Terjadi kesalahan!</strong>
                  <ul>
                    <li v-for="(message, key) in this.errorTryout" v-bind:key="key">{{message}}</li>
                  </ul>
                </div>
                <form>
                  <div class="form-horizontal form-bordered">
                    <div class="form-group">
                      <label class="col-md-2 control-label">Jenjang *</label>
                      <div class="col-md-6 col-xs-6">
                          <select class="form-control" disabled v-model="jenjang" @change="resetKelas()">
                              <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                          </select>
                      </div>
                    </div>
                    <div class="form-group" v-if="jenjang">
                        <label class="col-md-2 control-label">Kelas *</label>
                        <div class="col-md-6 col-xs-6">
                          <div v-if="jenjang === 'SD'">
                            <select class="form-control" disabled v-model="kelas">
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                          </div>
                          <div v-if="jenjang === 'SMP'">
                            <select class="form-control" disabled v-model="kelas">
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                            </select>
                          </div>
                          <div v-if="jenjang === 'SMA'">
                            <select class="form-control" disabled v-model="kelas">
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select>
                          </div>
                        </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Tipe *</label>
                      <div class="col-md-8 col-xs-12">
                        <select name="type" v-model="typeTO">
                          <option value="SBMPTN">SBMPTN</option>
                          <option value="UJIAN_AKHIR_NASIONAL">UJIAN AKHIR NASIONAL</option>
                          <option value="UJIAN_AKHIR_SEKOLAH">UJIAN AKHIR SEKOLAH</option>
                          <option value="UJIAN_SEKOLAH">UJIAN SEKOLAH</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Varian *</label>
                      <div class="col-md-8 col-xs-12">
                        <select name="variant" v-model="variant">
                          <option value="INSTANT_COMPLETE">INSTANT</option>
                        </select>
                        <!-- INSTANT -->
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Pilih Tryout</label>
                      <div class="col-md-8 col-xs-12">
                        <button type="button" class="btn btn-inverse" @click="openTO">Klik Untuk Pilih Tryout</button>

                        <br />
                        <div class="note note-info" v-if="$store.state.tryoutgroup.dependency_id && TOFromEdit === ''">
                          <h4>{{dependencyName}}</h4>
                        </div>
                        <div class="note note-info" v-if="TOFromEdit !== '' && idContent !== null">
                          <h4>{{TOFromEdit}}</h4>
                        </div>
                        <button v-if="$store.state.tryoutgroup.dependency_id" type="button" class="btn btn-danger" @click="showModal = true">hapus</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- <div class="tab-pane fade" id="terjadwal" role="tabpanel" aria-labelledby="terjadwal-tab"> -->
                <div v-if="type_id === 4">
                <div class="alert alert-danger fade in m-b-15" v-if="this.errorTerjadwal.length > 0">
                  <span class="close" data-dismiss="alert">&times;</span>
                  <strong>Terjadi kesalahan!</strong>
                  <ul>
                    <li v-for="(message, key) in this.errorTerjadwal" v-bind:key="key">{{message}}</li>
                  </ul>
                </div>
                <form>
                  <div class="form-horizontal form-bordered">
                    <div class="form-group">
                      <label class="col-md-2 control-label">Jenjang *</label>
                      <div class="col-md-6 col-xs-6">
                          <select class="form-control" disabled v-model="jenjang" @change="resetKelas()">
                              <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                          </select>
                      </div>
                    </div>
                    <div class="form-group" v-if="jenjang">
                        <label class="col-md-2 control-label">Kelas *</label>
                        <div class="col-md-6 col-xs-6">
                          <div v-if="jenjang === 'SD'">
                            <select class="form-control" disabled v-model="kelas">
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                          </div>
                          <div v-if="jenjang === 'SMP'">
                            <select class="form-control" disabled v-model="kelas">
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                            </select>
                          </div>
                          <div v-if="jenjang === 'SMA'">
                            <select class="form-control" disabled v-model="kelas">
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select>
                          </div>
                        </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Tipe *</label>
                      <div class="col-md-8 col-xs-12">
                        <select name="type" v-model="typeTO">
                          <option value="SBMPTN">SBMPTN</option>
                          <option value="UJIAN_AKHIR_NASIONAL">UJIAN AKHIR NASIONAL</option>
                          <option value="UJIAN_AKHIR_SEKOLAH">UJIAN AKHIR SEKOLAH</option>
                          <option value="UJIAN_SEKOLAH">UJIAN SEKOLAH</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Varian *</label>
                      <div class="col-md-8 col-xs-12">
                        <!-- BERAGENDA -->
                        <select name="variant" v-model="variant">
                          <option value="SCHEDULED">BERAGENDA</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Pilih Tryout</label>
                      <div class="col-md-8 col-xs-12">
                        <button type="button" class="btn btn-inverse" @click="openTO" v-if="idContent === null">Klik Untuk Pilih Tryout</button>
                        <button type="button" class="btn btn-inverse" @click="openTO" v-if="idContent !== null">Ubah TO ...</button>
                        <br />
                        <div class="note note-info" v-if="$store.state.tryoutgroup.dependency_id && TOFromEdit === ''">
                          <h4>{{dependencyName}}</h4>
                        </div>
                        <div class="note note-info" v-if="TOFromEdit !== '' && idContent !== null">
                          <h4>{{TOFromEdit}}</h4>
                        </div>
                        <button v-if="$store.state.tryoutgroup.dependency_id" type="button" class="btn btn-danger" @click="showModal = true">hapus</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="idContent === null" type="button" class="btn btn-primary" @click="saveContent(type_id)">Simpan</button>
            <button v-if="idContent !== null" type="button" class="btn btn-primary" @click="updateKonten(type_id)">Update</button>
          </div>
        </div>
      </div>
    </div>
    <app-tryoutgroupchooser :params="{grade: kelas, status: 'PUBLISHED', type: typeTO, variant: variant}"
    ref="groupChooser" v-on:dblClicked="addDependency($event)"></app-tryoutgroupchooser>
  </div>
</template>
<style>
.row-bab{
    max-width: 100%;
    overflow-x: auto;
    padding-bottom: 10px;
    margin:0px;
}
.modal-body{
  /* max-height: none; */
  overflow: auto;
}
</style>
<script>
import BimbelService from '@/services/bimbel.js'
import BabBimbelService from '@/services/bimbel_bab.js'
import MateriBimbelService from '@/services/bimbel_materi.js'
import Modal from '@/components/plugins/Modal'
import Autocomplete from '@/components/plugins/Autocomplete'
import moment from 'moment'
import bab from "./Bab"
import TryoutGroupChooser from '@/components/tryout_group/TryoutGroupChooser'
import loader from '@/assets/loading.gif'

export default {
  name: 'paket-mapel',
  components: {
      bab,
    'app-modal': Modal,
    'app-tryoutgroupchooser': TryoutGroupChooser,
    'app-autocomplete': Autocomplete,
  },
  data: function() {
    return {
      loading: loader,
      showLoader: false,
      errorVideo: [],
      errorMateri: [],
      errorSoal: [],
      errorTryout: [],
      errorTerjadwal: [],
      errors: [],
      block: [],
      params: '',
      packData: [],
      showBab: false,
      idBab: '',
      name: '',
      block_package: '',
      bab_name: '',
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
      is_free: '',
      listBlockPackage: [],
      listBab: [],
      postState: 0,
      mapelId: '',

      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1,2,3,4,5,6,7,8,9,10,11,12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      babList: [],
      subBabList: [],
      jenjang: '',
      kelas: '',
      listVideo: [],
      updateState: 0,
      video_judul: '',
      video_judul_alt: '',
      materi_judul: '',
      type_id: 1,
      file: '',
      file_url: '',
      validFile: 0,
      babSelected: '',
      subBabSelected: '',
      subBabTitle: '',
      typeTO: 'SBMPTN',
      variant: 'SCHEDULED',
      showModal: false,
      TOSelected: [],
      dependencyName: '',
      idContent: null,
      updateSwitch: null,
      autoValueSubBab: '',
      autoValueBab: '',
      TOFromEdit: ''
    }
  },
  methods: {
    rectre: function(to) {
      this.$router.push(to)
    },
    loadData: function() {
        this.items = []
        this.packData= []
        var context = this
        this.params = this.$route.params.id
        BimbelService.getAllBlock(this.params, function(result) {
          if(result.success) {
            context.packData = result.data
            context.jenjang = result.data.jenjang
            context.kelas = result.data.grade
            context.mapelId = result.data.mapel_id
            context.getVideo()
            context.getBab()
            BabBimbelService.getItemBab(result.data.mapel_code, function(result) {
              if(result.success) {
                context.listBab = result.data
              }
            })
          }
        })
        BimbelService.getListPackage(function (result){
          if(result.success) {
            context.listBlockPackage = result.data
          }
        })

    },
    showForm: function () {
      this.emptyForm()
      $('#addBabModal').modal('show')
    },
    emptyForm: function() {
      this.postState = 0
      this.idBab = ''
      this.name = ''
      this.block_package = ''
      this.bab_name = ''
      this.start_date = ''
      this.end_date = ''
      this.start_time= ''
      this.end_time = ''
      this.is_free = false
    },
    validateFormBab: function() {
      this.errors = []
      if (this.name == '') this.errors.push('Nama wajib diisi')
      // if (this.block_package == '') this.errors.push('Bab wajib diisi')
      if (this.bab_name == '') this.errors.push('Pilihan Bab wajib diisi')
      if (this.start_date == '') this.errors.push('Start Date wajib diisi')
      if (this.start_time == '') this.errors.push('Start Time Pelajaran wajib diisi')
      if (this.end_time == '') this.errors.push('End Time Pelajaran wajib diisi')
      if (this.end_date == '') this.errors.push('End Date Pelajaran wajib diisi')

      return this.errors.length == 0
    },
    saveDataBab: function() {
      if (!this.validateFormBab()) {
        return
      }
        this.isLoading = true
        var context = this
        var body = {
            name: this.name,
            start_date : this.start_date + ' ' + this.start_time,
            bab_name : this.bab_name,
            is_free_access : this.is_free,
            block_package_id : this.$route.params.id,
            end_date : this.end_date + ' ' + this.end_time
        }
        BabBimbelService.addBab( body, function(result) {
          context.isLoading = false
          context.loadData()
          $('#addBabModal').modal('hide')
          alert('data berhasil disimpan')
        })
    },
    editDataBab : function() {
      if (!this.validateFormBab()) {
        return
      }
        // this.isLoading = true
        var context = this
        var body = {
            name: this.name,
            start_date : this.start_date + ' ' + this.start_time,
            bab_name : this.bab_name,
            is_free_access : this.is_free,
            block_package_id : this.$route.params.id,
            end_date : this.end_date + ' ' + this.end_time
        }
        BabBimbelService.editBab( [body, this.idBab], function(result) {
          context.loadData()
          context.postState = 0
          $('#addBabModal').modal('hide')
          alert('data berhasil diubah')
        })
    },
    detailBab: function(item) {
      this.postState = 1
      this.idBab = item.id
      this.name = item.name
      this.block_package = this.$route.params.id
      this.bab_name = item.bab_name
      this.start_date = moment(item.start_date).format("YYYY-MM-DD")
      this.end_date = moment(item.end_date).format("YYYY-MM-DD")
      this.start_time= moment(item.start_date).format("hh:mm:ss")
      this.end_time = moment(item.end_date).format("hh:mm:ss")
      this.is_free = item.is_free_access
    },
    addContentButton(sectionid) {
      this.idContent = null
      this.$store.commit('tryout_group_set_dependency_id', null)
      this.showFormContent()
    },
    showFormContent(){
      this.emptyFormContent()
      $('#kontenmodal').modal('show')
    },
    hideFormContent(){
      this.emptyFormContent()
      $('#kontenmodal').modal('hide')
    },
    emptyFormContent() {
      this.video_judul = ''
      this.video_judul_alt = ''
      this.file_url =''
      this.autoValueBab = ''
      this.autoValueSubBab = ''
      this.subBabList = []
      this.TOFromEdit = ''
      this.materi_judul = ''
      this.idContent = null
      this.type_id = 1
      this.validFile = 0
      this.babSelected = ''
      this.subBabSelected = ''
      // this.$refs.autocomplete.refresh()
      // this.$refs.subbabautocomplete.refresh()
    },
    openTO() {
      this.$refs.groupChooser.openGroupModal()
    },
    assignBab: function(result) {
      console.log(result)
      var injectSubbab = this.babList.find(function(element) {
        return element.id == result.data[0]
      })
      this.babSelected = injectSubbab
    },
    assignSubBab: function(result) {
      var selectSubbab = this.babSelected.subs.find(function(element) {
        return element.id == result.data[0]
      })
      this.subBabSelected = selectSubbab.kode
      this.subBabTitle = selectSubbab.nama
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0]
      this.showLoader = true
      if(this.file.type === 'application/pdf') this.processUpload()
      else this.validFile = 2
    },
    convertURL(value){
      if (value === '') return ''
      var b = value.split('/')
      return b[5]
    },
    processUpload() {
      this.validFile = false
      var context = this
      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('request', '{"block_package_id":"'+this.$route.params.id+'"}')
      MateriBimbelService.uploadFile(formData ,function (result){
        if(result.success) {
          context.file_url = result.data.value
          context.validFile = 1
        } else {
          context.validFile = 2
        }
        context.showLoader = false
      })
    },
    resetKelas() {
      this.kelas = ''
    },
    addDependency: function (group) {
      this.TOFromEdit = ''
      this.TOSelected = group
      this.dependencyName = group.data[0]
      this.$store.commit('tryout_group_set_dependency_id', group.id)
    },
    removeDependency: function () {
      this.showModal = false
      this.dependencyName = ''
      this.TOSelected = []
      this.$store.commit('tryout_group_set_dependency_id', null)
    },
    getVideo: function() {
      var context= this
      MateriBimbelService.getListVideo({grade:this.packData.grade, mapel_id: this.packData.mapel_id} ,function (result){
        if(result.success) {
          context.listVideo = result.data
        }
      })
    },
    getBab: function() {
      var context= this
      MateriBimbelService.getBabSubbab(this.packData.mapel_code ,function (result){
        if(result.success) {
          context.babList = result.data
        }
      })
    },
    validateForm: function(body) {
      this.errorVideo = []
      this.errorMateri = []
      this.errorSoal = []
      this.errorTryout = []
      this.errorTerjadwal = []

      if(body.type_id === 1){
        if (!body.title || body.title == '' ) this.errorVideo.push('Judul wajib diisi')
        if (!body.value ) this.errorVideo.push('Judul Video wajib dipilih')
        if (!body.reference_id ) this.errorVideo.push('Video wajib diisi')
        return this.errorVideo.length == 0
      }
      if(body.type_id === 2) {
        if (!body.title || body.title == '' ) this.errorMateri.push('Judul wajib diisi')
        if (!body.value ) this.errorMateri.push('File tidak terisi atau tidak sesuai')
        return this.errorMateri.length == 0
      }
      if(body.type_id === 3){
         if (this.babSelected == '') this.errorSoal.push('Bab wajib diisi')
         if (this.subBabSelected  == '') this.errorSoal.push('Sub Bab wajib diisi')
        return this.errorSoal.length == 0
      }
      if(body.type_id === 4) {
        if (!body.title || body.title == '' ) this.errorTerjadwal.push('Tryout wajib Dipilih')
        return this.errorTerjadwal.length == 0
      }
      if(body.type_id === 5) {
        if (!body.title || body.title == '' ) this.errorTryout.push('Tryout wajib Dipilih')
        return this.errorTryout.length == 0
      }
    },
    saveContent: function(type){
      var body = {}
      var context = this
      this.isLoading = false
      if(type === 1) body = {
        title : this.video_judul_alt !== '' ? this.video_judul_alt : this.video_judul.title,
        value : this.video_judul.youtube_url,
        jenjang : this.jenjang,
        grade : this.kelas,
        reference_id : this.video_judul.id,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 2) body = {
        title : this.materi_judul,
        value : this.file_url,
        jenjang : this.jenjang,
        grade : this.kelas,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 3) body = {
        title : this.babSelected.nama + ' - ' + this.subBabTitle,
        jenjang : this.jenjang,
        grade : this.kelas,
        reference_id : this.packData.mapel_code + this.babSelected.kode + this.subBabSelected,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 4) body= {
        title : this.TOSelected.data[0],
        jenjang : this.jenjang,
        grade : this.kelas,
        reference_id : this.TOSelected.id,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 5) body= {
        title : this.TOSelected.data[0],
        jenjang : this.jenjang,
        grade : this.kelas,
        type_id: type,
        reference_id : this.TOSelected.id,
        section_id : parseInt(this.$route.query.section)
      }

      if (!this.validateForm(body)) {
        return
      }
      MateriBimbelService.addContent(body, (result) => {
          if (result.success) {
            context.isLoading = false
            alert('Data telah disimpan')
            $('#kontenmodal').modal('hide')
            context.loadData()
          }
      })
    },
    editContent: function (item) {
      var context = this
      this.updateSwitch = item.type.type
      this.idContent = item.id
      this.$store.commit('tryout_group_set_dependency_id', null)
      var contentTab = ''
      MateriBimbelService.getOneContent(item.id, (result) => {
        console.log(result)
        if (result.success) {
          if(result.data.type.type === 'VIDEO'){
            this.type_id = 1
            contentTab = 'video'
            this.kelas = result.data.grade
            this.jenjang = result.data.jenjang
            setTimeout(function(){
              context.video_judul = context.listVideo.find(function(element) {
                return element.id == parseInt(result.data.reference_id)
              })
            }, 2000)
            if(result.data.title !== null) this.video_judul_alt = result.data.title
          }

          if(result.data.type.type === 'LESSON'){
            contentTab = 'materi'
            this.type_id = 2
            this.kelas = result.data.grade
            this.jenjang = result.data.jenjang
            this.file_url = result.data.value
            this.materi_judul = result.data.title
          }
          if(result.data.type.type === 'ITEM'){
            contentTab = 'latihan'
            this.type_id = 3
            this.kelas = result.data.grade
            this.jenjang = result.data.jenjang
            var bab = result.data.reference_id.substring(2,4)
            context.babSelected = context.babList.find(function(element) {
              return element.kode == bab
            })
            context.subBabSelected = result.data.reference_id.substring(4,6)
            context.autoValueBab = context.babSelected.nama
            var setSubBab = context.babSelected.subs.find(function(element) {
              return element.kode == context.subBabSelected
            })
            context.autoValueSubBab = setSubBab.nama
            context.$nextTick(function () {
              context.$refs.autocomplete.refill(context.babSelected.nama)
              context.$refs.subbabautocomplete.refill(setSubBab.nama)
            })
          }
          if(result.data.type.type === 'INSTANT'){
            this.type_id = 5
            this.variant = 'INSTANT_COMPLETE'
            this.kelas = result.data.grade
            this.jenjang = result.data.jenjang
            this.TOFromEdit = result.data.title
            this.TOSelected = {
              id: parseInt(result.data.reference_id),
              data: [result.data.title, '', result.data.grade]
            }
          }
          if(result.data.type.type === 'SCHEDULED'){
            contentTab = 'terjadwal'
            this.type_id = 4
            this.variant = 'SCHEDULED'
            this.kelas = result.data.grade
            this.jenjang = result.data.jenjang
            this.TOFromEdit = result.data.title
            this.TOSelected = {
              id: parseInt(result.data.reference_id),
              data: [result.data.title, '', result.data.grade]
            }
          }
          setTimeout(function() {
            $('#kontenmodal').modal('show')
            // $('#myTab a[href="#'+contentTab+'"]').tab('show')
          }, 1200)

        }
      })
    },
    updateKonten: function(type){
      var body = {}
      var context = this
      this.isLoading = true
      if(type === 1) body = {
        title : this.video_judul_alt !== '' ? this.video_judul_alt : this.video_judul.title,
        value : this.video_judul.youtube_url,
        jenjang : this.jenjang,
        grade : this.kelas,
        reference_id : this.video_judul.id,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 2) body = {
        title : this.materi_judul,
        value : this.file_url,
        jenjang : this.jenjang,
        grade : this.kelas,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 3) body = {
        title : this.babSelected.nama + ' - ' + this.subBabTitle,
        jenjang : this.jenjang,
        grade : this.kelas,
        reference_id : this.packData.mapel_code + this.babSelected.kode + this.subBabSelected,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 4) body= {
        title : this.TOSelected.data[0],
        jenjang : this.jenjang,
        grade : this.kelas,
        reference_id : this.TOSelected.id,
        type_id: type,
        section_id : parseInt(this.$route.query.section)
      }
      if(type === 5) body= {
        title : this.TOSelected.data[0],
        jenjang : this.jenjang,
        grade : this.kelas,
        type_id: type,
        reference_id : this.TOSelected.id,
        section_id : parseInt(this.$route.query.section)
      }

      if (!this.validateForm(body)) {
        return
      }

      MateriBimbelService.updateContent({body: body, id: this.idContent}, (result) => {
          if (result.success) {
            context.isLoading = false
            alert('Data telah diupdate')
            context.idContent = null
            $('#kontenmodal').modal('hide')
            context.loadData()
          }
      })
    }
  },
  mounted() {
    this.loadData()
    var context = this
    DatepickerPlugin.init("#startDate", function(value) {
      context.start_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    DatepickerPlugin.init("#endDate", function(value) {
      context.end_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    ClockpickerPlugin.init("#startTime", function(value) {
      context.start_time = value + ":00";
    })

    ClockpickerPlugin.init("#endTime", function(value) {
      context.end_time = value + ":00";
    })
  },
  watch: {
    babSelected() {
      var context = this
      if(this.babList.length > 0) {
        var findSubbab = this.babList.find(function(element) {
          return element.kode == context.babSelected.kode
        })
        if(findSubbab) this.subBabList = findSubbab.subs
      }
    },
    type_id(to, from) {
      if(to === 1) $('#my-tab a[href="#video"]').tab('show')
      if(to === 2) $('#my-tab a[href="#materi"]').tab('show')
      if(to === 3) $('#my-tab a[href="#latihan"]').tab('show')
      if(to === 5) {
        $('#my-tab a[href="#tryout"]').tab('show')
        this.variant = 'INSTANT_COMPLETE'
      }
      if(to === 4) {
        $('#my-tab a[href="#terjadwal"]').tab('show')
        this.variant = 'SCHEDULED'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaketMapel.vue?adf72d00